export function unescapeString(text: string) {
  return text.replace(/\\[\\"']/g, (match) => match.charAt(1));
}

export function doubleUnescapeString(text: string) {
  let t = text.replace(/\\\\\\[\\"']/g, (match) => match.charAt(1));
  t = t.replace(/\\\\[\\"']/g, (match) => match.charAt(1));
  return t.replace(/\\[\\"']/g, () => "");
}
